/**
 * Launcher tab — apps ZTNA que o usuario logado pode acessar.
 * Filtragem server-side via permissao app:<slug>:access.
 */
import { Alert, Badge, Button, Card, Grid, Group, Stack, Text, Title } from '@mantine/core'
import { IconExternalLink } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { meApi } from '@/api/me'

export function ApplicationsLauncherTab() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['me', 'ztna-apps'],
    queryFn: () => meApi.listZtnaApps(),
  })

  if (isLoading) return <Text size="sm" c="dimmed">Carregando aplicativos...</Text>
  if (error) return <Alert color="red">Falha ao carregar aplicativos</Alert>
  if (!data || data.total === 0) {
    return (
      <Alert color="blue" variant="light">
        Você ainda não tem acesso a nenhum aplicativo ZTNA. Solicite acesso ao administrador.
      </Alert>
    )
  }

  return (
    <Stack gap="md">
      <Title order={5}>Meus aplicativos ({data.total})</Title>
      <Grid>
        {data.items.map((app) => (
          <Grid.Col span={{ base: 12, sm: 6, md: 4 }} key={app.id}>
            <Card withBorder padding="md">
              <Stack gap="xs">
                <Group justify="space-between" align="flex-start">
                  <Text fw={600} size="md" lineClamp={1}>
                    {app.display_name || app.slug}
                  </Text>
                  <Badge
                    size="xs"
                    color={app.enabled ? 'green' : 'orange'}
                    variant="light"
                  >
                    {app.enabled ? 'Ativo' : 'Pausado'}
                  </Badge>
                </Group>
                <Text size="xs" c="dimmed" ff="monospace" lineClamp={1} title={app.hostname}>
                  {app.hostname}
                </Text>
                <Group gap={4}>
                  <Badge size="xs" variant="light" color="gray">{app.environment}</Badge>
                </Group>
                <Button
                  component="a"
                  href={`https://${app.hostname}/`}
                  target="_blank"
                  rel="noopener"
                  leftSection={<IconExternalLink size={14} />}
                  variant="filled"
                  fullWidth
                  disabled={!app.enabled}
                >
                  Abrir
                </Button>
              </Stack>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
    </Stack>
  )
}
